import { ChangeDetectionStrategy,Component, Input } from '@angular/core';
import { KeysResult } from 'fuzzysort';

import { KeysOfUnion } from './fuzzysort-helper';

export type FuzzyMatchPart = {
    match: string
}

@Component({
    selector: 'admin-fuzzy-sort-result-highlight',
    imports: [],
    templateUrl: './fuzzy-sort-result-highlight.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './fuzzy-sort-result-highlight.component.scss'
})
export class FuzzySortResultHighlightComponent<T> {
    @Input()
    result: KeysResult<T>;

    @Input()
    fuzzySearchKeys: Array<KeysOfUnion<T>>;

    @Input()
    key: KeysOfUnion<T>;

    indexOfFuzzySearchKey(key: KeysOfUnion<T>): number {
        return this.fuzzySearchKeys.indexOf(key);
    }

    highlight(): (string | FuzzyMatchPart)[] {
        let context = this.result[this.indexOfFuzzySearchKey(this.key)];
        // fuzzysort v4 returns [target] (an empty string when the key did not match) instead of an empty array
        let result = context?.target ? context.highlight((match, _index) => {
            return {
                match
            } as FuzzyMatchPart;
        }) : [];
        if (!result.some(part => typeof part === 'object')) {
            return [((this.result.obj) as any)[this.key]];
        }
        return result;
    }
}
